import React from 'react';
import {Input, Label, Title} from 'components';
import i18n from 'i18next';

type VideoFormProps = {
  value?: string;
  setValue: (newValue: string) => void;
  disabled?: boolean;
};

function VideoForm({value, setValue, disabled}: VideoFormProps) {
  return (
    <>
      <Title.Sub>
        {i18n.t('wisbitPage.addComponentModal.videoForm.title')}
      </Title.Sub>
      <Label
        htmlFor="video-form"
        label={i18n.t('wisbitPage.addComponentModal.videoForm.linkLabel')}
      >
        <Input
          id="video-form"
          type="url"
          value={value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setValue(event.target.value)
          }
          disabled={disabled}
        />
      </Label>
    </>
  );
}

export default VideoForm;
